import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const PhpLesson4 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        <?php
        $name = "Pete Attah";
        $age = 30;
        $is_admin = true;
        ?>

        `
      );
      const code1 = (
        'text',
        `
        <?php
        $name = "Pete Attah";
        $name = 30;
        ?>

        `
      );

      const code2 = (
        'text',
        `
        <?php
        $name = "Sunday Nwachukwu";
        $age = 30;

        var_dump ($name) //string(16) Sunday Nwachukwu
        var_dump ($age)  //int (30)
        ?>

        `
      );
      const code3 = (
        'text',
        `
        <?php
        $foo = 10;
        $Foo = 20;

        echo $foo;  //Outputs 10
        echo $Foo;  //Outputs 20

        ?>

        `
      );




  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>Variable Declaration</strong></h3>
    <p>In PHP, you can declare a variable by using the <b>$</b> symbol followed by the name of the variable. For example:</p>
    <CopyBlock
      language={"php"}
      text={code}
      showLineNumbers={lineNumbers}
      theme={dracula}
      wrapLines={true}
      codeBlock
      />
    <br />
    <p>You can also use the <b>var keyword</b> to declare a variable, but this is not recommended, as it is deprecated in PHP 7.3 and later versions.</p>
    <p>The <b>var</b> keyword creates a property in a class. Since PHP 5, it is equivalent to the <b>public keyword</b>.</p>
    <p>Since PHP 5, the keywords <b>private</b>, <b>protected</b> and <b>public</b> should be used instead.</p>

    <p>It is important to note that in PHP, the type of a variable is determined by the context in which it is used.</p>
    <p>This means just like Javascript, PHP is also a dynamically typed language. For example, the following code is valid:</p>
    <CopyBlock
      language={"php"}
      text={code1}
      showLineNumbers={lineNumbers}
      theme={dracula}
      wrapLines={true}
      codeBlock
    />
    <p>In this case, <b>$name</b> is first assigned a string value, and then it is assigned an integer value.</p>
    <p>The type of the variable changes automatically to match the value that is assigned to it.</p>
    <p>You can use the <b>var_dump()</b> function to see the type and value of a variable:</p>

    <CopyBlock
      language={"php"}
      text={code2}
      showLineNumbers={lineNumbers}
      theme={dracula}
      wrapLines={true}
      codeBlock
    />
    <p>In general, it is a good idea to give your variables descriptive names to make your code easier to understand.</p><br/>
  </div>

<div className="alert alert-secondary" role="alert">

<h3><strong>Case Sensitivity</strong></h3>
    <p>In PHP, variables are case-sensitive. This means that a variable named <b>$foo</b> is different from a variable named <b>$Foo</b> or <b>$FOO</b>.</p>
    <p>Here is an example to illustrate this:</p>
    <CopyBlock
    language={"php"}
    text={code3}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
  <p>It is a good practice to use descriptive and meaningful variable names, and to be consistent with your naming conventions.
   You might find it easier to use all lowercase letters and separate words with underscores <b>(e.g. $customer_name)</b> or to use camelCase <b>(e.g. $customerName)</b>.</p>
  <p>It's important to note that PHP also has a concept of <b>superglobals</b>, which are special variables that are available in all scopes throughout a PHP script.</p>
  <p>These variables are always prefixed with an underscore <b>(e.g. $_SERVER, $_POST, $_GET)</b>. These variables are not case-sensitive, so <b>$_POST</b> and <b>$_post</b> refer to the same variable.</p>

  <p>It's important to note that PHP also has a concept of <b>superglobals</b>, which are special variables that are available in all scopes throughout a PHP script.</p>
  <p>These variables are always prefixed with an underscore <b>(e.g. $_SERVER, $_POST, $_GET)</b>. These variables are not case-sensitive, so <b>$_POST</b> and <b>$_post</b> refer to the same variable.</p>



 </div>

</div>
</div>
</div>
</HTMLCourseNavProvider>
  )
}
export default PhpLesson4
